export default {
    routerName: '画像編集',
    routerNamePic: '画像カットアウト',
    pic: {
        name: '画像名',
        thumb: 'サムネイル',
        image: '画像',
        status: '状態',
        open: '有効',
        close: '無効',
        description: '記述',
        sortOrder: 'ソート',
    },
};
